// import { GtfsData, StopsByLine, StopsByDestination, StopPoint } from "./types";

// if (needRefresh || !hasLineShapes) {
//   //call...
//
//     this.lineShapes = getLineShapes(gtfsUri).await;
//     localStorage[localStorageKey] = JSON.stringify(this.lineShapes);
//     localStorage[prefix + "lineShapes-publicationDate"] = pubDate;
//   });
// }

import axios, { AxiosResponse } from "axios";
import { localStorageProxy } from "../lib/utils";
import { GtfsLineShapes, GtfsAnnotatedLineShapes } from '@/lib/gtfsTypes';


async function gtfsGetLineShapes(
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
  line: string,
  stopid?: string,
  shapeid?: string,
  currentDate?: string,
): Promise<GtfsLineShapes> {
  let url = `/line-shapes-discovery?reseau=${network}&line=${line}`;
  if (typeof stopid !== 'undefined' && stopid != '') {
    url = `${url}&stop=${stopid}`;
  }
  if (typeof currentDate !== 'undefined') {
    url = `${url}&date=${currentDate}`;
  }
  if (encodeUriPath) {
    url = encodeURIComponent(url);
  }
  url = `${gtfsUri}${url}`;

  return axios({ method: "get", url }).then(resp => {
    let rawData: GtfsAnnotatedLineShapes[] = Object.values(resp.data.items);
    if (shapeid !== null) {
      rawData.filter(shape => shape.ShapeId == shapeid);
    }
    let shapeList: GtfsAnnotatedLineShapes[] = rawData;
    let shapes: string[] = shapeList.map(s =>
      decodeURI(s.Shape.points)
    );
    return { shapes };
  });
}

export default function (
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
  line: string,
  stopid?: string,
  shapeid?: string,
  currentDate?: string,
): Promise<GtfsLineShapes> {
  let prefix = `gtfs-${network}-`;
  if (shapeid !== null && shapeid !== undefined) {
    prefix += `${shapeid}`;
  }
  if (currentDate !== null && currentDate !== undefined) {
    prefix += `${currentDate}`;
  }
  let proxyGetValue: Function = localStorageProxy(
    prefix + "lineShapes" + line + stopid,
    () => gtfsGetLineShapes(gtfsUri, encodeUriPath, network, line, stopid, shapeid, currentDate),
  );

  return proxyGetValue();
}
